import { denormalisedResponseEntities } from './data';
import { currentUserShowSuccess } from '../ducks/user.duck';

/**
 * Persist a cart object to the current user's privateData and keep the Redux
 * currentUser in sync.
 *
 * Shared by the ListingPage and CartPage cart thunks so the persistence logic
 * lives in exactly one place. Resolves with the saved cart.
 *
 * @param {Object} sdk - Sharetribe SDK instance
 * @param {Function} dispatch - Redux dispatch
 * @param {Object} newCart - The full cart object to persist
 * @returns {Promise<Object>} resolves with newCart
 */
export const updateCartInProfile = (sdk, dispatch, newCart) => {
  return sdk.currentUser
    .updateProfile(
      { privateData: { cart: newCart } },
      { expand: true, include: ['profileImage'] }
    )
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length === 1) {
        dispatch(currentUserShowSuccess(entities[0]));
      }
      return newCart;
    });
};
